import React, { useEffect, useState } from "react"

import axios from "../http/axios"

import { useTranslation } from "react-i18next"

import XButtonIcon from "../svg/x-button.inline.svg"

import PlusIcon from "../svg/plus-icon.inline.svg"

import { useCurrentUser } from "../components/CurrentUserContext"

import { useSidemenu } from "../components/SidemenuContext"

import { notification } from "antd"

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
)

const SideNavSendMessageSection = props => {
  const { isSendMessageMenuOpen, toggleSendMessageMenu } = useSidemenu()
  const { currentUser } = useCurrentUser()
  const [nameTriggered, setNameTriggered] = useState(false)
  const [lastNameLengTriggered, setLastNameLengTriggered] = useState(false)
  const [emailTriggered, setEmailTriggered] = useState(false)

  let nameLengthZero = nameTriggered ? "email-not-valid" : ""
  let lastNameLengthZero = lastNameLengTriggered ? "email-not-valid" : ""
  let emailLengthZero = emailTriggered ? "email-not-valid" : ""

  const [, setFormValuesValid] = useState([])

  const openNotification = placement => {
    notification.info({
      message: t("school.feedback.sent"),
      placement,
    })
  }

  const openNotificationError = placement => {
    notification.info({
      message: t("school.feedback.failedToSend"),
      placement,
    })
  }

  const [userChildren, setUserChildren] = useState([
    { id: 0, name: "", birthDate: "", admissionAge: "" },
  ])

  useEffect(() => {
    if (isSendMessageMenuOpen) {
      if (currentUser) {
        const obj = {
          authorEmail: currentUser?.email != null ? currentUser.email : "",
          authorFirstName:
            currentUser?.firstname != null ? currentUser.firstname : "",
          authorLastName:
            currentUser?.lastname != null ? currentUser.lastname : "",
          schoolManagerAccountId: "",
          content: "",
          meetingDate: "",
          meetingTime: "",
          languageCode: "",
          translatorNeeded: "",
          children: [
            {
              id: "",
              name: "",
              birthDate: "",
              admissionAge: "",
            },
          ],
        }

        setFormValues(obj)

        axios
          .get(`/accounts/${currentUser?.id}/children`)
          .then(res => {
            getUserChildren(res.data)
          })
          .catch(error => {
            console.log("error", error)
          })
      } else {
        getUserChildren(null)
      }
    }
  }, [isSendMessageMenuOpen])

  const handleAddClickChildren = () => {
    setUserChildren([
      ...userChildren,
      { id: 0, name: "", birthDate: "", admissionAge: "" },
    ])
  }

  const handleRemoveClickChildren = index => {
    const list = [...userChildren]
    list.splice(index, 1)
    setUserChildren(list)
  }

  const handleInputChangeUserChildren = (e, index) => {
    const { name, value } = e.target
    const list = [...userChildren]
    list[index][name] = value
    setUserChildren(list)
  }

  const getUserChildren = items => {
    if (items) {
      const userChildrenData = items
      let mass = []
      for (let child of userChildrenData) {
        mass.push({
          name: false,
          birthDate: false,
          admissionAge: false,
        })

        if (child.fullname) {
          child.name = child.fullname
          delete child.fullname
        }

        if (child.dateOfBirth) {
          child.birthDate = new Date(child.dateOfBirth)
            .toISOString()
            .slice(0, 10)
          delete child.dateOfBirth
        }
      }

      setFormValuesValid(mass)
      setUserChildren(userChildrenData)
    }
  }

  const school = props.school
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const [formValues, setFormValues] = useState({
    authorEmail: "",
    authorFirstName: "",
    authorLastName: "",
    schoolManagerAccountId: "",
    content: "",
    meetingDate: "",
    meetingTime: "",
    languageCode: "",
    translatorNeeded: "",
    children: [
      {
        id: "",
        name: "",
        birthDate: "",
        admissionAge: "",
      },
    ],
  })

  const handleReset = () => {
    const container = document.getElementById("side-school-item-send-message")
    Array.from(container.querySelectorAll("input")).forEach(
      input => (input.value = "")
    )
    Array.from(container.querySelectorAll("textarea")).forEach(
      textarea => (textarea.value = "")
    )
  }

  function handleSubmit(e) {
    e.preventDefault()

    if (!formValues.authorFirstName || formValues.authorFirstName === "") {
      setNameTriggered(true)
    }
    if (!formValues.authorLastName || formValues.authorLastName === "") {
      setLastNameLengTriggered(true)
    }
    if (!formValues.authorEmail || formValues.authorEmail === "") {
      setEmailTriggered(true)
    } else {
      validEmailRegex.test(formValues.authorEmail)
        ? setEmailTriggered(false)
        : setEmailTriggered(true)
    }

    if (
      formValues.authorEmail &&
      formValues.authorFirstName &&
      formValues.authorLastName
    ) {
      axios
        .post("/messages", {
          authorEmail: formValues.authorEmail,
          authorFirstName: formValues.authorFirstName,
          authorLastName: formValues.authorLastName,
          languageCode: currentLang,
          schoolManagerAccountId: school?.dataContext?.managers[0]?.accountId,
          content: formValues.content,
          children:
            currentUser && (userChildren != null || userChildren[0].name != "")
              ? userChildren
              : inputList,
        })
        .then(() => {
          openNotification()
          handleReset()
          toggleSendMessageMenu()
        })
        .catch(err => {
          console.log("error:", err)
          openNotificationError()
        })
    }
  }

  const handleInputChanges = e => {
    e.persist()
    setFormValues(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
    setNameTriggered(false)
    setLastNameLengTriggered(false)
    setEmailTriggered(false)
  }

  //----ADD CHILD
  const [inputList, setInputList] = useState([
    { id: 0, name: "", birthDate: "", admissionAge: "" },
  ])

  const handleAddClick = () => {
    setInputList([
      ...inputList,
      { id: 0, name: "", birthDate: "", admissionAge: "" },
    ])
  }

  const handleRemoveClick = index => {
    const list = [...inputList]
    list.splice(index, 1)
    setInputList(list)
  }

  const handleInputChangeChildren = (e, index) => {
    const { name, value } = e.target
    const list = [...inputList]
    list[index][name] = value
    setInputList(list)
  }

  return (
    <>
      {isSendMessageMenuOpen && (
        <div id="side-school-item-send-message" className="sidenav-school-item">
          {/* <!---- CLOSE BUTTON ----> */}
          <div
            className="ps-5 sign-up-btn f-ac"
            onClick={toggleSendMessageMenu}
          >
            <div className="x-button-wrapper f-ac f-jc curs-P">
              <XButtonIcon className="x-button" />
            </div>
            <div className="sign-up-text">{t("main.sideNav.close")}</div>
          </div>
          <div className="container">
            {/* <!-- FORM FIELDS --> */}
            <div className="side-nav-school-content">
              <div className="feedback-block-title mb-4">
                {t("school.feedback.sendMessage")}
              </div>
              <form onSubmit={handleSubmit} noValidate>
                <div className="name-email-fields feedback-fields">
                  <div className="input-group">
                    <input
                      type="text"
                      className={`form-field-error ${nameLengthZero}`}
                      name="authorFirstName"
                      required
                      value={formValues.authorFirstName}
                      onChange={handleInputChanges}
                    />
                    <label>{t("main.header.firstName")}</label>
                    {nameLengthZero && (
                      <span className={`error ${nameLengthZero}`}>
                        {t("main.header.ivalidData")}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <input
                      className={`form-field-error ${lastNameLengthZero}`}
                      type="text"
                      name="authorLastName"
                      required
                      value={formValues.authorLastName}
                      onChange={handleInputChanges}
                    />
                    <label>{t("main.userProfileMap.lastName")}</label>
                    {lastNameLengthZero && (
                      <span className={`error ${lastNameLengthZero}`}>
                        {t("main.header.ivalidData")}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <input
                      type="email"
                      className={`form-field-error ${emailLengthZero}`}
                      name="authorEmail"
                      required
                      value={formValues.authorEmail}
                      onChange={handleInputChanges}
                    />
                    <label>{t("main.header.email")}</label>
                    {emailLengthZero && (
                      <span className={`error ${emailLengthZero}`}>
                        {t("main.header.ivalidData")}
                      </span>
                    )}
                  </div>
                </div>

                {currentUser &&
                (userChildren != null || userChildren[0].name != "")
                  ? userChildren.map((x, i) => {
                      return (
                        <div
                          key={"input_" + i}
                          className="other-fields feedback-fields"
                        >
                          <div className="input-group">
                            <input
                              type="text"
                              name="name"
                              required
                              value={x.name}
                              onChange={e =>
                                handleInputChangeUserChildren(e, i)
                              }
                            />
                            <label>{t("main.header.childFullName")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              name="birthDate"
                              required
                              onFocus={e => {
                                e.currentTarget.type = "date"
                                e.currentTarget.focus()
                              }}
                              onBlur={e => (e.currentTarget.type = "text")}
                              value={x.birthDate}
                              onChange={e =>
                                handleInputChangeUserChildren(e, i)
                              }
                            />
                            <label>{t("main.header.dateBirth")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="number"
                              name="admissionAge"
                              required
                              value={x.admissionAge}
                              onChange={e =>
                                handleInputChangeUserChildren(e, i)
                              }
                            />
                            <label>{t("main.header.planningSchool")}</label>
                          </div>

                          <div className="add-child-wrapper f-js f-ac curs-P">
                            {userChildren.length - 1 === i && (
                              <>
                                <PlusIcon
                                  className="plus-icon"
                                  onClick={handleAddClickChildren}
                                />
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={handleAddClickChildren}
                                >
                                  {t("main.userProfileMap.addChild")}
                                </div>
                              </>
                            )}
                            {userChildren.length !== 1 &&
                              userChildren.length - 1 === i && (
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={() => handleRemoveClickChildren(i)}
                                >
                                  {t("main.userProfileTabs.removeChild")}
                                </div>
                              )}
                          </div>
                        </div>
                      )
                    })
                  : inputList.map((x, i) => {
                      return (
                        <div
                          key={"input_" + i}
                          className="other-fields feedback-fields"
                        >
                          <div className="input-group">
                            <input
                              type="text"
                              name="name"
                              required
                              value={x.name}
                              onChange={e => handleInputChangeChildren(e, i)}
                            />
                            <label>{t("main.header.childFullName")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              name="birthDate"
                              required
                              onFocus={e => {
                                e.currentTarget.type = "date"
                                e.currentTarget.focus()
                              }}
                              onBlur={e => (e.currentTarget.type = "text")}
                              value={x.birthDate}
                              onChange={e => handleInputChangeChildren(e, i)}
                            />
                            <label>{t("main.header.dateBirth")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="number"
                              name="admissionAge"
                              required
                              value={x.admissionAge}
                              onChange={e => handleInputChangeChildren(e, i)}
                            />
                            <label>{t("main.header.planningSchool")}</label>
                          </div>

                          <div className="add-child-wrapper f-js f-ac curs-P">
                            {inputList.length - 1 === i && (
                              <>
                                <PlusIcon
                                  className="plus-icon"
                                  onClick={handleAddClick}
                                />
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={handleAddClick}
                                >
                                  {t("main.userProfileMap.addChild")}
                                </div>
                              </>
                            )}
                            {inputList.length !== 1 &&
                              inputList.length - 1 === i && (
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={() => handleRemoveClick(i)}
                                >
                                  {t("main.userProfileTabs.removeChild")}
                                </div>
                              )}
                          </div>
                        </div>
                      )
                    })}
                <textarea
                  className="school-info-textarea feedback-fields"
                  placeholder={t("main.header.yourMessage")}
                  name="content"
                  value={formValues.content}
                  onChange={handleInputChanges}
                ></textarea>
                <button
                  className="side-nav-school-item-submit-btn"
                  type="submit"
                >
                  {t("main.header.submit")}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SideNavSendMessageSection
